import { CopyableCommand } from "@/components/copy";

// maskedToken keeps a token's ends, enough to tell tokens apart on screen.
function maskedToken(token: string): string {
	return `${token.slice(0, 8)}${"•".repeat(16)}${token.slice(-4)}`;
}

// ConnectorCommand hands over the command that runs a tunnel's connector with
// its token. The page shows the token masked; copying takes it whole.
export function ConnectorCommand({ tokenValue }: { tokenValue: string }) {
	return (
		<div className="space-y-2">
			<CopyableCommand
				command={`lim tunnel run --token ${tokenValue}`}
				display={`lim tunnel run --token ${maskedToken(tokenValue)}`}
				label="Copy the connector command"
				autoFocus
			/>
			<p className="text-xs text-muted-foreground">The token is shown only once and runs this tunnel alone.</p>
		</div>
	);
}
